// @flow
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import HighchartsMore from 'highcharts/highcharts-more';
import React from 'react';

type Props = {
  options: any,
};

if (typeof Highcharts === 'object') {
  HighchartsMore(Highcharts);
}

export default ({ options }: Props) => (
  <HighchartsReact highcharts={Highcharts} options={options} />
);
